<h2 mat-dialog-title>{{ 'admin_single_poi.dialog.title' | translate }}</h2>
<p>{{ 'admin_single_poi.dialog.descr' | translate: {poi_name: data.poi_name[data.current_lang]} }}</p>
<mat-dialog-actions align="center" class="dialog-btns">
    <button mat-button (click)="onNoClick()">{{ 'admin_single_poi.dialog.cancel' | translate }}</button>
    <button mat-button (click)="unapprovePoi()" cdkFocusInitial class="dialog-confirm">{{ 'admin_single_poi.dialog.ok' | translate }}</button>
</mat-dialog-actions>

<app-loading-overlay [loading]="loading"></app-loading-overlay>